function loginReducer(state = [], action) {
    const { type, payload } = action;

    switch(type) {
        case "LOGIN_SUCCESS":
            let companies = payload.companies.map((c, index) => {
                return {
                    key: `comp_${index}`,
                    value: c,
                    text: c
                }
            })
            return Object.assign({}, state, { ...payload, companies });

        case "SET_COMPANY":
            let company = payload.company;
            return Object.assign({}, state, { company });

            case "USER_LOGOUT":
                return Object.assign({}, state, { token: "" });
        
        default:
            return state;
    }
}

export default loginReducer;